import { Modal } from 'antd'

import { ActionButton } from '@eastcoal/common/components/Button/ActionButton'
import { pick } from '@eastcoal/common/utils/object'

import { SubmitType } from '@eastcoal/formily/components/CrudForm/enums/SubmitType'
import { useCrudFormStore } from '@eastcoal/formily/components/CrudForm/Store/hooks/useStore'
import { useCrudModalFormStore } from '@eastcoal/formily/components/CrudModalForm/Store/hooks/useStore'

import { AuctionFeeConfirmModalButtonProps } from './interface'
import { useFeeConfirm } from './useFeeConfirm'

/**
 * 竞价场次编辑弹窗发布按钮（带服务费/入场费二次确认，提交成功后关闭弹窗）
 */
export const AuctionFeeConfirmModalSubmitButton = ({
  type = 'primary',
  children: externalChildren = '提交',
  ...restProps
}: AuctionFeeConfirmModalButtonProps) => {
  const { submitLoading } = useCrudFormStore(state =>
    pick(state, ['submitLoading'])
  )
  const { toggleModalOpen } = useCrudModalFormStore(state =>
    pick(state, ['toggleModalOpen'])
  )

  const {
    isModalOpen,
    confirmContent,
    handleClick,
    handleConfirm,
    handleCancel
  } = useFeeConfirm({
    // 与 CrudModalForm 原 SubmitButton 保持一致：提交成功后关闭弹窗
    onSubmitted: toggleModalOpen
  })

  return (
    <>
      <ActionButton
        loading={submitLoading}
        type={type}
        onClick={() => handleClick({ submitType: SubmitType.SUBMIT })}
        {...restProps}
      >
        {externalChildren}
      </ActionButton>
      <Modal
        cancelText='否'
        okText='是'
        open={isModalOpen}
        title='提示'
        onCancel={handleCancel}
        onOk={handleConfirm}
      >
        {confirmContent}
      </Modal>
    </>
  )
}
